var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLevel3 = function SvgLevel3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 16,
    rx: 8,
    fill: "#D889FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9631 4.3H13.0631V11.043H17.2321V12H11.9631V4.3ZM23.0804 6.17L20.5284 12H19.4504L16.8984 6.17H17.9984L20.0004 10.845L22.0464 6.17H23.0804ZM23.9537 12.066C23.7484 12.066 23.5724 11.9963 23.4257 11.857C23.279 11.7103 23.2057 11.527 23.2057 11.307C23.2057 11.0943 23.279 10.9183 23.4257 10.779C23.5724 10.6323 23.7484 10.559 23.9537 10.559C24.159 10.559 24.3314 10.6287 24.4707 10.768C24.61 10.9073 24.6797 11.087 24.6797 11.307C24.6797 11.527 24.6064 11.7103 24.4597 11.857C24.3204 11.9963 24.1517 12.066 23.9537 12.066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7711 7.435C32.4458 7.545 32.9628 7.798 33.3221 8.194C33.6815 8.58267 33.8611 9.06667 33.8611 9.646C33.8611 10.0933 33.7438 10.5077 33.5091 10.889C33.2745 11.263 32.9151 11.5637 32.4311 11.791C31.9545 12.0183 31.3678 12.132 30.6711 12.132C30.1285 12.132 29.5931 12.0623 29.0651 11.923C28.5445 11.7763 28.1008 11.571 27.7341 11.307L28.4271 9.943C28.7205 10.163 29.0578 10.3353 29.4391 10.46C29.8278 10.5773 30.2238 10.636 30.6271 10.636C31.0745 10.636 31.4265 10.5517 31.6831 10.383C31.9398 10.207 32.0681 9.96133 32.0681 9.646C32.0681 9.01533 31.5878 8.7 30.6271 8.7H29.8131V7.523L31.3971 5.73H28.1191V4.3H33.5091V5.455L31.7711 7.435Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLevel3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/level3.75fd3c758bc473abec686cf744200f1b.blank.svg";